(function($) {
	"use strict";

	const TOAST_IN_OUT_DURATION = 250;
	const TOAST = {
		SHORT: 3000,
		MEDIUM: 6000,
		LONG: 10000,
	};

	function Toast(text, duration, type) {
		let toastContainer = _getToastContainer();
		let durationClass = _getDurationClass(duration);
		let toast = document.createElement("div");

		toast.classList.add("toast");
		toast.classList.add(`toast_${type}`);
		toast.classList.add(durationClass);
		toast.innerHTML = text;
		toastContainer.appendChild(toast);
		toast.classList.add("toast_in");
		toast.addEventListener('click', () => this.remove());

		this.element = toast;
		this.text = text;
		this.duration = duration;
		this.type = type;

		this.show();
	}

	Toast.prototype.DURATION = TOAST;

	Toast.prototype.show = function() {
		this.timeout = setTimeout(() => {
			this.remove();
		}, this.duration + TOAST_IN_OUT_DURATION);
	};

	Toast.prototype.remove = function() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = null;
		this.element.classList.remove("toast_in");
		this.element.classList.add("toast_out");
		setTimeout(() => this.element.parentNode.removeChild(this.element), TOAST_IN_OUT_DURATION);
	};

	function create(text = "Il y a eu une erreur./There was an error.", duration = TOAST.SHORT, type = "danger") {
		return new Toast(text, duration, type);
	}

	function _getToastContainer() {
		let toastContainer = document.querySelector(".toasts");
		
		if (toastContainer) {
			return toastContainer;
		}

		toastContainer = document.createElement("div");
		toastContainer.classList.add("toasts");
		document.body.appendChild(toastContainer);
		return toastContainer;
	}

	function _getDurationClass(duration) {
		switch (duration) {
			case TOAST.SHORT:
				return 'toast_short';
			case TOAST.MEDIUM:
				return 'toast_medium';
			case TOAST.LONG:
				return 'toast_long';
		}
	}
	
	Fw.component.export("toast", {
		create,
		DURATION: TOAST,
	});
	
})(jQuery);